import repository from '@/repositories/repository'

export default baseUrl => {
    baseUrl = `${baseUrl}/relatorio-papel-lotacao`

    return {
        index(params) {
            return repository.post(`${baseUrl}`, params)
        },
        create() {
            return repository.get(`${baseUrl}/create`)
        },
        list(params) {
            return repository.post(`${baseUrl}/list`, params)
        },
    }
}